import FaqAccordion from "./components/FaqAccordion";
import HeroStepForm from "./components/HeroStepForm";

FaqAccordion();
HeroStepForm();
